"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M2.713 5.958a1 1 0 01.574-1.916l10 3c.95.285.95 1.63 0 1.916l-10 3a1 1 0 01-.574-1.916L9.52 8 2.713 5.958z"];
//# sourceMappingURL=greater-than.js.map